import { useLocation } from "react-router-dom";
import { useFestivalTheme } from "@/context/FestivalThemeContext";

/**
 * FestivalLanterns — Diwali sky-lantern ambience in the page side margins.
 * Uses the owner's PNG art from /public. Renders only while a festival theme
 * enables it, only on screens >= 1360px, always behind content (z-0),
 * pointer-events none, motion = transform/opacity only, and fully static for
 * prefers-reduced-motion. Remove the whole effect with one flag:
 */
const LANTERNS_ENABLED = true;

const FLOAT_SRC = "/paqvero-sky-lantern.png";
const HANG_SRC = "/paqvero-sky-lantern-with-string.png";

/* [side, x (vw), width (px), duration (s), delay (s), far (depth blur)] */
const HANGING = [
  ["left", 1.2, 96, 7.6, 0, false],
  ["left", 3.9, 54, 8.8, 0.8, true],
  ["left", 6.6, 72, 8.1, 1.6, false],
  ["right", 1.6, 110, 8.4, 0.4, false],
  ["right", 4.6, 58, 7.2, 2.0, true],
  ["right", 7.3, 78, 8.9, 1.0, false],
];
const FLOATING = [
  ["left", 2.6, 64, 54, 4, false],
  ["left", 5.4, 42, 70, 23, true],
  ["right", 2.9, 56, 62, 12, false],
  ["right", 6.1, 46, 76, 35, true],
];

export default function FestivalLanterns() {
  const { isFestival, decor } = useFestivalTheme();
  const { pathname } = useLocation();
  /* decoration density per surface (Phase 2): checkout/cart stay clean,
     catalogue + PRIME get hanging lanterns only, homepage gets the full sky */
  const quiet = pathname.startsWith("/checkout") || pathname.startsWith("/cart");
  const minimal = pathname.startsWith("/shop") || pathname.startsWith("/prime");
  if (!LANTERNS_ENABLED || !isFestival || quiet || (!decor.hanging_lanterns && !decor.sky_lanterns)) return null;

  return (
    <div className="pq-lanterns" aria-hidden="true" data-testid="festival-lanterns">
      {decor.hanging_lanterns && HANGING.map(([side, x, w, dur, delay, far], i) => (
        <div
          key={`h${i}`}
          className="pq-lan pq-lan-hang"
          style={{ [side]: `${x}vw`, width: w, animationDuration: `${dur}s`, animationDelay: `${delay}s` }}
        >
          <img src={HANG_SRC} alt="" loading="lazy" aria-hidden="true" className={`pq-lan-img${far ? " pq-lan-far" : ""}`} />
        </div>
      ))}
      {decor.sky_lanterns && !minimal && FLOATING.map(([side, x, w, dur, delay, far], i) => (
        <div key={`f${i}`} className="pq-lan-float" style={{ [side]: `${x}vw`, width: w }}>
          <div className="pq-lan-rise" style={{ animationDuration: `${dur}s`, animationDelay: `${delay}s` }}>
            <img src={FLOAT_SRC} alt="" loading="lazy" aria-hidden="true" className={`pq-lan-img pq-lan-wobble${far ? " pq-lan-far" : ""}`} />
          </div>
        </div>
      ))}
    </div>
  );
}
